module.exports = __webpack_public_path__ + "static/Oral rehabilitation-98c4015c624e4eed8529afbee5b7cc9f.jpg";